import { createSelector } from 'reselect';

import { RenderState } from 'render/render.state';


export interface ModalPanelState {
  modalsStack: { modalName: string; props: unknown }[];
}

export const selectModalPanelState = (state: RenderState): ModalPanelState => state.renderModalPanel;

export const selectIsModalOpen = (name: string): ((state: RenderState) => boolean) => createSelector(
  selectModalPanelState,
  (state: ModalPanelState) => state.modalsStack.some(({ modalName }) => name === modalName)
);

export const selectModalProps = (name: string): ((state: RenderState) => unknown) => createSelector(
  selectModalPanelState,
  (state: ModalPanelState) => {
    const modal = state.modalsStack.find(({ modalName }) => name === modalName);
    return modal?.props;
  }
);
